import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  isMini: false,
  sessionMini: null,
};

const sidebarSlice = createSlice({
  name: "sidebar",
  initialState,
  reducers: {
    toggleSidebar: (state) => {
      if (state.sessionMini !== null) {
        state.sessionMini = !state.sessionMini;
      } else {
        state.isMini = !state.isMini;
      }
    },
    setSessionMini: (state, action) => {
      state.sessionMini = action.payload;
    },
  },
});

export const { toggleSidebar, setSessionMini } = sidebarSlice.actions;

export const sidebarReducer = sidebarSlice.reducer;
